{
	"online": "online",
	"offline": "offline",
	"invalid": "Invalid status"
}
